import React from 'react';
import { colors } from '../designSystem';

interface AboutSectionProps {
  content: string;
}

export const AboutSection: React.FC<AboutSectionProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div className="px-6 py-6 border-b" style={{ borderColor: colors.divider }}>
      <h3 className="text-lg font-semibold mb-3" style={{ color: colors.textPrimary }}>
        אודות
      </h3>
      <p
        className="leading-relaxed whitespace-pre-wrap"
        style={{ color: colors.textSecondary, lineHeight: '1.6' }}
      >
        {content}
      </p>
    </div>
  );
};
